__webpack_require__.p = "/invest-game/";